import {AbstractParameter} from "parameters/AbstractParameter.js"
import Tone from 'tone';
import {getAllValuesAtStep} from 'parameters/getValueAtStep.js';
import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
const abs = Math.abs;
const pow = Math.pow;
const sqrt = Math.sqrt;
const sqr = (x) => Math.pow(x, 2);

export default superclass => class extends superclass  {
    currentPath = undefined;
    currentPosition = 1;

    stopDrawing() {
        this.currentPath = undefined;
        this.currentPosition = 1;
        this.pencilDown = false;
    }

    setupDrawable() {
        this.pencilXParameter = new AbstractParameter(
            "pencilX", this, (a,b) => [],
            {
                defaultValue: null,
                min: 0,
                max: WIDTH,
                exactAutomation: true
            });
        this.registerParameter(this.pencilXParameter);

        this.pencilYParameter = new AbstractParameter(
            "pencilY", this, (a,b) => [],
            {
                defaultValue: null,
                min: 0,
                max: HEIGHT,
                exactAutomation: true
            });
        this.registerParameter(this.pencilYParameter);
    }

    applyPencilAutomations() {
        if (this.pencilXParameter.isRecordingMix ||
            this.pencilXParameter.isRecording ||
            !this.pencilXParameter.isPlayingMix) {
            // we dont apply if were recording
            return;
        }
        if (this.pencilXParameter.get(true) === null &&
            this.pencilYParameter.get(true) === null) {
            let stepNumber = this.pencilXParameter.currentStep;
            let xValues = getAllValuesAtStep(stepNumber, this.pencilXParameter.mixAutomation);
            let yValues = getAllValuesAtStep(stepNumber, this.pencilYParameter.mixAutomation);

            let pencilDown = this.pencilDown;
            for (let i in xValues) {
                if (xValues[i] !== undefined) {
                    if (xValues[i] === null) {
                        pencilDown = false;
                    } else {
                        pencilDown = true;
                    }
                    this.calculatePath(xValues[i], yValues[i], stepNumber);
                } 
            }
            this.pencilDown = pencilDown;
        }
    };

    setPencil(x,y) {
        this.pencilDown = x !== undefined && x !== null;
        this.pencilXParameter.set(x, false);
        this.pencilYParameter.set(y, false);
        this.calculatePath(x,y);
        this.lastX = undefined;
        this.lastY = undefined;
    }

    get pencilX() {
        return this.pencilXParameter && this.pencilXParameter.get();
    }

    get pencilY() {
        return this.pencilYParameter && this.pencilYParameter.get();
    }

    calculatePath(x,y, stepNumber) {
        if (!x || !y) {
            return;
        }
        if (!this.currentPath) {
            this.currentPath = [];
        }
        // otherwise we append x,y
        this.currentPath = [... this.currentPath, {x,y, stepNumber}];
    }

    get isRecordingMix() {
        return this.pencilXParameter.isRecordingMix;
    }

    applyPath(ratio, stepNumber) {
        ratio *= 0.5;
        let point = this.currentPath[this.currentPosition];
        let lastPoint = this.currentPath[this.currentPosition - 1];
        if (point === undefined || lastPoint === undefined) {
            if (!this.pencilDown) {
                this.currentPath = undefined;
                this.currentPosition = 1;
            }
            return {};
        }
        
        let xDiff = point.x - lastPoint.x;
        let yDiff = point.y - lastPoint.y;
        this.currentPosition++;
        let bulk = {};

        let _parameters = this._parameters;
        let numParameters = ratio * _parameters.length;
        let start = (this.currentPosition*numParameters) % _parameters.length;
        let parameterKeys = _parameters.slice(start, start + numParameters);
        if (parameterKeys.length < numParameters) {
            parameterKeys = [... parameterKeys, ... _parameters.slice(0, numParameters - parameterKeys.length)];
        }

        for (let parameter of parameterKeys) {
            let {id, value} = parameter.moveCoordinates(
                xDiff, yDiff, true, this.rampTime / 1000.0);
            bulk[id] = value;
        }
        return bulk;
    }
}
